import { useRef, useEffect } from 'react';
import { Toast } from 'primereact/toast';
import { registerToastShow, registerToastClear } from './toastService';

// Single source of truth for every toast name used with `showToast` / `clearToast`.
// A name passed to those helpers MUST be listed here, otherwise there is no
// Toast instance to drive it. (The lookups below are also null-safe, so an
// unregistered name degrades to a no-op instead of throwing.)
const TOAST_NAMES = [
  'errorToast',
  'warningToast',
  'successToast',
  'copyToast',
  'connectionErrorToast',
  'micAccessDeniedToast',
  'reconnectingToast',
  'reconnectingSuccessToast',
  'meetingFullToast',
  'createRoomError',
  'relayRetryToast',
  'boardSaveToast',
  'activeFileLoadToast',
  'filesLoadToast',
  'chatHistoryToast',
  'chatToast',
  'screenShareApprovedToast',
  'screenShareDeniedToast',
  'screenShareRevokedToast',
  'screenShareApproveError',
  'screenShareRevokeError',
  'screenShareRequestError',
  'screenShareDenyError',
  'screenShareRequestSentToast'
] as const;

export const ToastManager = () => {
  const toasts = useRef<Record<string, Toast | null>>({});

  useEffect(() => {
    registerToastShow((name: string, severity, summary, detail, sticky) => {
      toasts.current[name]?.show({
        severity,
        summary,
        detail,
        sticky,
        life: 3000
      });
    });
    registerToastClear((name: string) => {
      toasts.current[name]?.clear();
    });
  }, []);

  return (
    <>
      {TOAST_NAMES.map((name) => (
        <Toast
          key={name}
          className="custom-toast"
          ref={(el) => {
            toasts.current[name] = el;
          }}
          position="top-center"
        />
      ))}
    </>
  );
};
